import dayjs from "dayjs";
import "font-awesome/css/font-awesome.min.css";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import config from "../../config";
import "../../Style/HomeCards.css";
import { authFetch } from "../../utils/Security/authFetch";

function HomeCards() {
  const isAdmin = localStorage.getItem("isAdmin") === "true";
  const isUser = localStorage.getItem("isUser") === "true";
  const navigate = useNavigate();
  const isForTelebras = localStorage.getItem("isForTelebras") === "true";
  const isForPetrobras = localStorage.getItem("isForPetrobras") === "true";
  const isForNilesat = localStorage.getItem("isForNilesat") === "true";

  const [OpenChangesCount, setOpenChangesCount] = useState<number | null>(null);
  const [OpenTasksCount, setOpenTasksCount] = useState<number | null>(null);
  const [Allincidents, setAllIncidents] = useState<number | null>(null);
  const [Allchanges, setAllChanges] = useState<number | null>(null);
  const [alltasks, setAllTasks] = useState<number | null>(null);
  const [allProblems, setAllProblems] = useState<number | null>(null);
  const [allRmas, setAllRmas] = useState<number | null>(null);

  const [OpenProblemsCount, setOpenProblemCount] = useState<number | null>(
    null,
  );
  const [OpenRmasCount, setOpenRmaCount] = useState<number | null>(null);
  const [openIncidentCount, setOpenIncidentCount] = useState<number | null>(
    null,
  );
  const isRestrictedAdmin =
  isAdmin && (isForTelebras || isForPetrobras || isForNilesat);
  const isPetrobrasAdmin = isAdmin && isForPetrobras;
  const isNilesatAdmin = isAdmin && isForNilesat;

useEffect(() => {
  const fetchData = async () => {
    try {
      const incidentBase = isRestrictedAdmin
        ? `${config.apiBaseUrl}/api/incidents/telebras`
        : `${config.apiBaseUrl}/api/incidents`;

      const userId = localStorage.getItem("userid");

      const incidentOpenUrl = isRestrictedAdmin
        ? `${incidentBase}/count-open-this-month?userId=${userId}`
        : `${incidentBase}/count-open-this-month`;

      const incidentCountUrl = isRestrictedAdmin
        ? `${incidentBase}/countallincidents?userId=${userId}`
        : `${incidentBase}/countallincidents`;

      const taskBase = isPetrobrasAdmin
        ? `${config.apiBaseUrl}/api/tasks/petrobras`
        : `${config.apiBaseUrl}/api/tasks`;
      const rmaBase = isNilesatAdmin
        ? `${config.apiBaseUrl}/api/rmas/nilesat`
        : `${config.apiBaseUrl}/api/rmas`;
        const [
          incidentOpen,
          changesOpen,
          tasksOpen,
          problemsOpen,
          rmasOpen,
          incidentsAll,
          tasksAll,
          changesAll,
          problemsAll,
          rmasAll,
        ] = await Promise.all([
          authFetch(incidentOpenUrl).then((res) => res.json()),

          authFetch(
            `${config.apiBaseUrl}/api/changes/count-open-this-month`,
          ).then((res) => res.json()),

          authFetch(`${taskBase}/count-open-this-month`).then((res) =>
            res.json(),
          ),

          authFetch(
            `${config.apiBaseUrl}/api/problems/count-open-this-month`,
          ).then((res) => res.json()),
    authFetch(`${rmaBase}/count-open-this-month`).then((res) =>
            res.json(),
          ),

          authFetch(incidentCountUrl).then((res) => res.json()),

          authFetch(`${taskBase}/countalltasks`).then((res) => res.json()),

          authFetch(`${config.apiBaseUrl}/api/changes/countallchanges`).then(
            (res) => res.json(),
          ),

          authFetch(`${config.apiBaseUrl}/api/problems/countallproblems`).then(
            (res) => res.json(),
          ),

          authFetch(`${rmaBase}/countallrmas`).then((res) => res.json()),
        ]);

        setOpenIncidentCount(incidentOpen);
        setOpenChangesCount(changesOpen);
        setOpenTasksCount(tasksOpen);
        setOpenProblemCount(problemsOpen);
        setOpenRmaCount(rmasOpen);
        setAllIncidents(incidentsAll);
        setAllChanges(changesAll);
        setAllTasks(tasksAll);
        setAllProblems(problemsAll);
        setAllRmas(rmasAll);
      } catch (error) {
        console.error(error);
      }
    };

    fetchData();
  }, []);

  const currentMonthYear = dayjs().format("MMMM YYYY");

  const cards = [
    {
      title: "Incidents",
      description: `Opened Incidents In ${currentMonthYear}`,
      text: `${openIncidentCount} Out of ${Allincidents}`,
      icon: "fa fa-line-chart",
      path: "/incident",
    },
    {
      title: "Changes",
      description: `Opened Changes In ${currentMonthYear}`,
      text: isRestrictedAdmin
        ? `0 Out of 0`
        : `${OpenChangesCount} Out Of ${Allchanges}`,
      icon: "fa fa-exchange",
      path: "/change",
    },
    {
      title: "Tasks",
      description: `Opened Tasks In ${currentMonthYear}`,
      text:
        isRestrictedAdmin && !isPetrobrasAdmin
          ? `0 Out of 0`
          : `${OpenTasksCount} Out of ${alltasks}`,
      icon: "fa fa-tasks",
      path: "/task",
    },
    {
      title: "Problems",
      description: `Opened Problems In ${currentMonthYear}`,
      text: isRestrictedAdmin
        ? `0 Out of 0`
        : `${OpenProblemsCount} Out of ${allProblems}`,
      icon: "fa fa-bug",
      path: "/problem",
    },
    {
      title: "RMA",
      description: `Opened RMAs In ${currentMonthYear}`,
      text:
        isRestrictedAdmin && !isNilesatAdmin
          ? `0 Out of 0`
          : `${OpenRmasCount} Out of ${allRmas}`,
      icon: "fa fa-reply",
      path: "/rma-request",
    },
    {
      title: "Service Request",
      text: isRestrictedAdmin
        ? `0 Out of 0`
        : `${openIncidentCount} Out of ${Allincidents}`,
      icon: "fa fa-line-chart",
      path: "/admin",
    },
  ];

  const visibleCards = isAdmin
    ? cards
    : isUser
      ? [cards[0], cards[1], cards[2]]
      : [];

  return (
    <div className="cards-container">
      {visibleCards.map((card, index) => (
        <div
          className={`card1 card-${card.title.toLowerCase()}`}
          key={index}
          onClick={() => card.path && navigate(card.path)}
        >
          <div className="card1-header">
            {card.icon && (
              <div className="card1-icon">
                <i className={card.icon}></i>
              </div>
            )}
            <h3 className="card1-title">{card.title}</h3>
          </div>
          <p className="card1-description">{card.description}</p>
          <div className="card-count">
            {card.text && <p className="card-text">{card.text}</p>}
          </div>
          <div className="card-divider"></div>
        </div>
      ))}
    </div>
  );
}

export default HomeCards;
